/**
 * 登录方式 ID 枚举
 */
export const LOGIN_TYPE_ID = {
  WECHAT: 1,
  QQ: 2,
  PHONE: 3,
} as const

export const LOGIN_TYPE_ENUM = {
  WECHAT: 'WX',
  QQ: 'QQ',
  PHONE: 'SMS'
}

/**
 * 验证状态枚举
 */
export const VERIFICATION_STATUS = {
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  WAITING: 'WAITING',
} as const

export type VerificationStatus = typeof VERIFICATION_STATUS[keyof typeof VERIFICATION_STATUS]

/**
 * 弹窗类型（用于统一管理弹窗显示/关闭）
 */
export type ModalType =
  | 'wechat' // 微信验证
  | 'phone' // 手机验证
  | 'wechatLogin' // 微信登录
  | 'verificationFail' // 验证失败
  | 'deleteNotice' // 账号注销确认
